<div class="row">
  <div class="cell-lg-12">
    <div class="bg-white p-4">
      <div>
        <div class="border bd-default no-border p-2">
          <!-- Vue authentifiée : cartes groupées par module (Structure / Traitement / …) -->
          <div *ngIf="habilitation">
            <div *ngFor="let item of dashBoard">
              <h4>{{ item.title | translate }}</h4>

              <!-- Boucle sur les groupes (Structure, Traitement, …) -->
              <div *ngFor="let group of item.content" class="mb-4">

                <!-- En-tête du groupe -->
                <div class="d-flex align-items-center mb-2 mt-3" style="border-bottom:2px solid #17a2b8;padding-bottom:4px">
                  <span [class]="group.icon + ' fg-darkCyan mr-2'" style="font-size:16px"></span>
                  <h5 class="fg-darkCyan mb-0" style="font-size:14px;font-weight:700;letter-spacing:.5px">
                    {{ group.libelle | translate | uppercase }}
                  </h5>
                </div>

                <!-- Cartes des items du groupe -->
                <div class="row" *ngIf="group.children && group.children.length > 0">
                  <ng-container *ngFor="let subItem of group.children">

                    <!-- Item simple -->
                    <ng-container *ngIf="!subItem.subMenu">
                      <div class="col-lg-3 col-md-4 mt-2" *ngIf="authService.isVisible(subItem.idObject)">
                        <div [class]="'more-info-box fg-white ' + color" (click)="goToUrl(subItem.url)">
                          <div class="content">
                            <h2 class="text-bold mb-0">{{ subItem.id }}</h2>
                          </div>
                          <div class="icon">
                            <span [class]="subItem.icon"></span>
                          </div>
                          <a href="javascript:void(0)" class="more taille">
                            {{ subItem.libelle | translate }}&nbsp;&nbsp;
                            <span class="mif-arrow-right"></span>
                          </a>
                        </div>
                      </div>
                    </ng-container>

                    <!-- Sous-groupe : on affiche ses enfants comme cartes -->
                    <ng-container *ngIf="subItem.subMenu && authService.isVisible(subItem.idObject)">
                      <ng-container *ngFor="let subSubItem of subItem.children">
                        <div class="col-lg-3 col-md-4 mt-2">
                          <div [class]="'more-info-box fg-white ' + color" (click)="goToUrl(subSubItem.url)">
                            <div class="content">
                              <h2 class="text-bold mb-0">{{ subSubItem.id }}</h2>
                            </div>
                            <div class="icon">
                              <span [class]="subSubItem.icon"></span>
                            </div>
                            <a href="javascript:void(0)" class="more taille">
                              {{ subSubItem.libelle | translate }}&nbsp;&nbsp;
                              <span class="mif-arrow-right"></span>
                            </a>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>

                  </ng-container>
                </div>

                <!-- Groupe vide (ex: Traitement sans items pour l'instant) -->
                <div *ngIf="!group.children || group.children.length === 0"
                     class="p-3 fg-gray" style="font-size:13px;font-style:italic">
                  <span class="mif-info mr-1"></span> Bientôt disponible
                </div>

              </div>
            </div>
          </div>
          <div>
            <div *ngIf="!habilitation">
              <h4 > {{ "Services" | translate }}</h4>
              <div class="row">
                <div
                  class="cell-lg-2 cell-md-4 mt-2"
                  *ngFor="let item of habilitations; let i = index"
                >
                  <div
                    [class]="'more-info-box fg-white ' + color"
                    (click)="onSelectService(item)"
                  >
                    <div class="content">
                      <h2 class="text-bold mb-0">{{ i + 1 }}</h2>
                    </div>
                    <div class="icon">
                      <span class="mif-info"></span>
                    </div>
                    <a href="javascript:void(0)" class="more taille bg-cyan">
                      {{ item.name | translate }}
                      <span class="mif-arrow-right"></span
                      ></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
